import Vue from 'vue'
import App from './App.vue'
import './scss/reset.scss'
import './scss/fonts.scss'
import Vuelidate from "vuelidate/src";
import router from "./router";
import VueGtag from "vue-gtag";

Vue.use(Vuelidate);
Vue.use(router);

Vue.use(VueGtag, {
  config: { id: "G-6YDW057DR9" }  
}, router);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  validations:{},
  router
}).$mount('#app');
